import React from 'react';
import { IconProps } from '../models';

const IconsColor: React.FC<IconProps> = ({ iconName, width, height, fillColor, strokeColor }) => {
  return (
    <>
      {/* Dashboard Icon */}
      {iconName === "dashboard" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
        </svg>
      }

      {/* Hotels Icon */}
      {iconName === "hotels" &&
        <svg width={width} height={height} viewBox="0 0 16 16" fill={fillColor ?? "none"} xmlns="http://www.w3.org/2000/svg">
          <path d="M6.66663 8H9.33329" stroke={strokeColor ?? "currentColor"} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6.66663 5.33331H9.33329" stroke={strokeColor ?? "currentColor"} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M9.33329 14V12C9.33329 11.6464 9.19282 11.3073 8.94277 11.0572C8.69272 10.8072 8.35358 10.6667 7.99996 10.6667C7.64634 10.6667 7.3072 10.8072 7.05715 11.0572C6.8071 11.3073 6.66663 11.6464 6.66663 12V14" stroke={strokeColor ?? "currentColor"} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M4.00004 6.66669H2.66671C2.31309 6.66669 1.97395 6.80716 1.7239 7.05721C1.47385 7.30726 1.33337 7.6464 1.33337 8.00002V12.6667C1.33337 13.0203 1.47385 13.3594 1.7239 13.6095C1.97395 13.8595 2.31309 14 2.66671 14H13.3334C13.687 14 14.0261 13.8595 14.2762 13.6095C14.5262 13.3594 14.6667 13.0203 14.6667 12.6667V6.00002C14.6667 5.6464 14.5262 5.30726 14.2762 5.05721C14.0261 4.80716 13.687 4.66669 13.3334 4.66669H12" stroke={strokeColor ?? "currentColor"} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M4 14V3.33333C4 2.97971 4.14048 2.64057 4.39052 2.39052C4.64057 2.14048 4.97971 2 5.33333 2H10.6667C11.0203 2 11.3594 2.14048 11.6095 2.39052C11.8595 2.64057 12 2.97971 12 3.33333V14" stroke={strokeColor ?? "currentColor"} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      }

      {/* Packages Icon */}
      {iconName === "packages" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 2v20M2 12h20" />
        </svg>
      }

      {/* Excursions Icon */}
      {iconName === "excursions" &&
        <svg width={width} height={height} viewBox="0 0 16 16" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10.8267 5.17334L9.62401 8.78067C9.55855 8.97706 9.44827 9.15551 9.30189 9.30189C9.15551 9.44827 8.97706 9.55855 8.78067 9.62401L5.17334 10.8267L6.37601 7.21934C6.44146 7.02295 6.55175 6.8445 6.69812 6.69812C6.8445 6.55175 7.02295 6.44146 7.21934 6.37601L10.8267 5.17334Z" />
          <path d="M8.00016 14.6666C11.6821 14.6666 14.6668 11.6818 14.6668 7.99992C14.6668 4.31802 11.6821 1.33325 8.00016 1.33325C4.31826 1.33325 1.3335 4.31802 1.3335 7.99992C1.3335 11.6818 4.31826 14.6666 8.00016 14.6666Z" />
        </svg>
      }

      {/* Transportation Icon */}
      {iconName === "transportation" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="6" cy="19" r="3" />
          <path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15" />
          <circle cx="18" cy="5" r="3" />
        </svg>
      }

      {/* Places Icon */}
      {iconName === "places" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      }

      {/* Guides Icon */}
      {iconName === "guides" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      }

      {/* Agents Icon - Updated to User with Cog/Settings */}
      {iconName === "agents" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
          <circle cx="20" cy="8" r="2" />
          <path d="M20 10v.5" />
          <path d="M20 5.5V6" />
          <path d="M22 8h-.5" />
          <path d="M18.5 8H18" />
        </svg>
      }

      {/* Star Icon */}
      {iconName === "star" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <path d="M12 2L15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      }

      {/* Location Icon */}
      {iconName === "location" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      }

      {/* Email Icon */}
      {iconName === "mailIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <polyline points="22,6 12,13 2,6" />
        </svg>
      }

      {/* Phone Icon */}
      {iconName === "phoneIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      }

      {/* Password Icon */}
      {iconName === "passwordIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      }

      {/* Eye Icon (show password) */}
      {iconName === "eyeIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      }

      {/* Eye Off Icon (hide password) */}
      {iconName === "eyeOffIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
          <line x1="1" y1="1" x2="23" y2="23" />
        </svg>
      }

      {/* Error Icon */}
      {iconName === "errorIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      }

      {/* Warning Icon */}
      {iconName === "warningIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      }

      {/* Search Icon */}
      {iconName === "searchIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8" />
          <path d="M21 21l-4.35-4.35" />
        </svg>
      }

      {/* Chevron Down Icon */}
      {iconName === "chevronDown" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      }

      {/* Chevron Left Icon */}
      {iconName === "chevronLeft" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
      }

      {/* Chevron Right Icon */}
      {iconName === "chevronRight" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      }

      {/* Check Icon */}
      {iconName === "checkIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      }

      {/* Edit / Pencil Icon */}
      {iconName === "editIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 20h9" />
          <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
        </svg>
      }

      {/* Close Icon (X) */}
      {iconName === "closeIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      }

      {/* Calendar Icon */}
      {iconName === "calendarIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      }

      {/* Duplicate/Copy Icon */}
      {iconName === "duplicateIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      }

      {/* Delete Icon */}
      {/* {iconName === "deleteIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        >
          <path d="M3 6h18" />
          <path d="M8 6V4h8v2" />
          <rect x="6" y="6" width="12" height="14" rx="2" />
          <line x1="10" y1="11" x2="10" y2="17" />
          <line x1="14" y1="11" x2="14" y2="17" />
        </svg>

      } */}
      {/* {iconName === "deleteIcon" &&
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" style={{ fill: strokeColor ? strokeColor == "none" ? "#f00" : strokeColor : "#f00" }}><path d="M0 0h24v24H0z" fill="none"/><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
      } */}
      {iconName === "deleteIcon" &&
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={strokeColor ?? "currentColor"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-trash2-icon lucide-trash-2" style={{ width: width, height: height }}><path d="M10 11v6" /><path d="M14 11v6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" /><path d="M3 6h18" /><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>
      }

      {/* Warning Sign Icon */}
      {iconName === "warningSign" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      }

      {/* Filter Icon */}
      {iconName === "filterIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
      }

      {/* Clear Filter Icon (Filter with X) */}
      {iconName === "clearFilterIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
          <line x1="15" y1="5" x2="19" y2="9" />
          <line x1="19" y1="5" x2="15" y2="9" />
        </svg>
      }

      {/* More Vert (vertical ellipsis) Icon */}
      {iconName === "moreVert" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={strokeColor ?? fillColor ?? "currentColor"} stroke="none">
          <circle cx="12" cy="6" r="1.5" />
          <circle cx="12" cy="12" r="1.5" />
          <circle cx="12" cy="18" r="1.5" />
        </svg>
      }

      {/* Gear / Settings Icon */}
      {iconName === "gearIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
        </svg>
      }

      {/* Person Icon (single user) */}
      {iconName === "personIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      }

      {/* Dollar / Currency Icon */}
      {iconName === "dollarIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      }

      {/* Meal / Fork & Knife Icon */}
      {iconName === "mealIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8 2v4M8 22V10M8 10c0 2.2-1.8 4-4 4H2" />
          <path d="M16 2v20M16 14c0 2.2 1.8 4 4 4h2" />
          <path d="M16 6h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2" />
        </svg>
      }

      {iconName === "copyIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      }

      {iconName === "uploadIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" />
          <line x1="12" y1="3" x2="12" y2="15" />
        </svg>
      }

      {iconName === "checkCircleIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="16 9 10.5 15 8 12.5" />
        </svg>
      }

      {iconName === "fileIcon" &&
        <svg width={width} height={height} viewBox="0 0 24 24" fill={fillColor ?? "none"} stroke={strokeColor ?? "currentColor"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="8" y1="13" x2="16" y2="13" />
          <line x1="8" y1="17" x2="16" y2="17" />
        </svg>
      }

      {/* Activity history icon */}
      {iconName === "activityHistoryIcon" &&
        <svg
          width={width}
          height={height}
          fill={strokeColor ?? "currentColor"}
          xmlns="http://www.w3.org/2000/svg"
          shape-rendering="geometricPrecision"
          text-rendering="geometricPrecision"
          image-rendering="optimizeQuality"
          fill-rule="evenodd"
          clip-rule="evenodd"
          viewBox="0 0 441 512.02"
        >
          <path
            d="M324.87 279.77c32.01 0 61.01 13.01 82.03 34.02 21.09 21 34.1 50.05 34.1 82.1 0 32.06-13.01 61.11-34.02 82.11l-1.32 1.22c-20.92 20.29-49.41 32.8-80.79 32.8-32.06 0-61.1-13.01-82.1-34.02-21.01-21-34.02-50.05-34.02-82.11s13.01-61.1 34.02-82.1c21-21.01 50.04-34.02 82.1-34.02zM243.11 38.08v54.18c.99 12.93 5.5 23.09 13.42 29.85 8.2 7.01 20.46 10.94 36.69 11.23l37.92-.04-88.03-95.22zm91.21 120.49-41.3-.04c-22.49-.35-40.21-6.4-52.9-17.24-13.23-11.31-20.68-27.35-22.19-47.23l-.11-1.74V25.29H62.87c-10.34 0-19.75 4.23-26.55 11.03-6.8 6.8-11.03 16.21-11.03 26.55v336.49c0 10.3 4.25 19.71 11.06 26.52 6.8 6.8 16.22 11.05 26.52 11.05h119.41c2.54 8.79 5.87 17.25 9.92 25.29H62.87c-17.28 0-33.02-7.08-44.41-18.46C7.08 432.37 0 416.64 0 399.36V62.87c0-17.26 7.08-32.98 18.45-44.36C29.89 7.08 45.61 0 62.87 0h173.88c4.11 0 7.76 1.96 10.07 5l109.39 118.34c2.24 2.43 3.34 5.49 3.34 8.55l.03 119.72c-8.18-1.97-16.62-3.25-25.26-3.79v-89.25zm-229.76 54.49c-6.98 0-12.64-5.66-12.64-12.64 0-6.99 5.66-12.65 12.64-12.65h150.49c6.98 0 12.65 5.66 12.65 12.65 0 6.98-5.67 12.64-12.65 12.64H104.56zm0 72.3c-6.98 0-12.64-5.66-12.64-12.65 0-6.98 5.66-12.64 12.64-12.64h142.52c3.71 0 7.05 1.6 9.37 4.15a149.03 149.03 0 0 0-30.54 21.14H104.56zm0 72.3c-6.98 0-12.64-5.66-12.64-12.65 0-6.98 5.66-12.64 12.64-12.64h86.2c-3.82 8.05-6.95 16.51-9.29 25.29h-76.91zm203.96-20.95h17.41c3.18 0 5.79 2.61 5.79 5.79v55.22h44.36c3.21 0 5.82 2.61 5.82 5.81v17.4c0 3.21-2.61 5.81-5.82 5.81H302.7V342.5c0-3.18 2.61-5.79 5.82-5.79z"
          />
        </svg>
      }
    </>
  );
};

export default IconsColor;

